import React from 'react'
import styled, { css } from 'styled-components'
import { IMaskInput } from 'react-imask'

function Input({ type, reverseStyle, mod, ...props }) {
  const mask = () => {
    if (type == 'price') {
      return {
        mask: Number,
        radix: '.',
        scale: 2,
        thousandsSeparator: '',
        unmask: true,
      }
    } else if (type == 'NumberMask') {
      return {
        mask: Number,
        scale: 0,
      }
    } else return null
  }

  return (
    <InputWrap ref={props.inputRef}>
      <Wrap>
        <Label>
          {props.label && <LabelName className="input-label">{props.label}</LabelName>}
          <InputInner>
            {/*<InputForm*/}
            {/*type={type}*/}
            {/*as={props.as || 'input'}*/}
            {/*autoComplete={props.disabledComplete && 'new-password'}*/}
            {/*{...props}*/}
            {/*{...mask()}*/}
            {/*/>*/}

            <InputFormMask
              {...mask()}
              onAccept={props.onChange}
              placeholder={props.placeholder}
              type="text"
              name={props.name}
              error={props.error}
              disabled={props.disabled}
              autoComplete={props.autoComplete}
              middle={props.middle}
              reverse={props.reverseStyle}
              value={props.value}
              mod={mod}
            />
          </InputInner>
        </Label>
      </Wrap>

      {props.error && (
        <ErrorWrap>
          <Error>{props.error}</Error>
        </ErrorWrap>
      )}
    </InputWrap>
  )
}

export default Input

const Wrap = styled.div``
const Label = styled.label`
  position: relative;
  display: block;
  margin: 0;
`
const LabelName = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #333333;
  padding-bottom: 12px;

  &:hover {
    opacity: 0.8;
  }
`
const InputInner = styled.div`
  position: relative;
`
const InputWrap = styled.div`
  width: 100%;
`
const ErrorWrap = styled.div`
  width: 100%;
  padding-top: 3px;
`
const Error = styled.div`
  color: #ff7272;
  line-height: 24px;
  //display: inline-block;
  font-size: 13px;
  padding-top: 3px;
  text-transform: lowercase;
`

const InputForm = styled.input.attrs({})`
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
  height: 42px;

  &:focus {
    border-color: #ffd54c;
  }

  ${p =>
    p.error &&
    css`
      border-color: #ff7272;
    `}

  ${p =>
    p.as === 'textarea' &&
    css`
      padding-top: 10px;
      padding-bottom: 10px;
      min-height: ${p.textareaHeight ? p.textareaHeight + 'px' : '85px'};
      min-width: 100%;
      max-width: 100%;
      width: 100% !important;
    `}
`
const InputFormMask = styled(({ middle, ...props }) => <IMaskInput {...props} />)`
  width: 100%;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 0 12px;
  font-size: 14px;
  height: 42px;

  &:focus {
    border-color: #ffd54c;
  }

  ${p =>
    p.mod &&
    css`
      padding: 0 10px;
      font-size: 12px;
      height: 25px;
      max-width: 60px;
    `}
`
